import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';

import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { styled } from '@mui/system'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
 import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export  default class  AddPaymentbox extends Component {

   constructor(props) {
      super();
	  
	  
    var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

 this.state = {
	 pmt_date: '',
 pmt_date1:'',open:false,name:'',pmt_id:0,cu_creditlimit:'0.00',errormessage:'',erropen:false,btndisabled:false,tab:"0", value:0,ledgerdata:[],masterlabel:'Select',statelabel:'select state',amount:'',discount:'', paymentdate:'',paidinto:'',paymentmethod:'',reference:'',
	  submitbtn:"Save",masterdata:[],Bankdata:[],veid:0,cuid:0,isprintremittanceadvance:'',trprintremittanceadvance:'',paymentdate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay,sin_id:0,bank:'',ledgerArray:[],newoutstandingamt:"0.00",
	  }
      
  }
  

  
 handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,errormessage:'',erropen:false,sin_id:0,Checkboxvalue:0,grandtot:'',discount:0, paymentdate:'',paidinto:'',paymentmethod:'',reference:'',paymentdate1:'',sinid:'',vbid:0,amount:'',ledgerArray:[],});
 let outstandingamts=this.props.total;
 let sinoid=this.props.id;
  let refnoo=this.props.refno;
  let disc=this.props.discount;
  let paids=this.props.paid;
 this.setState({grandtot:outstandingamts,sinid:sinoid,reference:refnoo,discount:disc,amount:paids});

};
 


onclickpaymentclose = (e) => {
	 this.setState({open:false});
} 
 

fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        pmt_date: dayjs(dateObj),
        pmt_date1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}




  handleChange = (event, newValue) => {
    this.setState({ tab: newValue });
	
	 this.setState({                   
     Checkbox: event.target.value      
   })
  }
  ledgerbind(){

 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getallbybank&le_cmp_id='+localStorage.getItem("ISIcmpid"))
	 .then((resp) => {     
	  let LedgerApi = resp.data.map(row => {
                      
          return {value:row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: [{value:'0', display:'Select'}].concat(LedgerApi)
        });
		
		
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}
 
 myChangeHandler = (event) => {
  const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;


if((nam==="grandtot") || (nam==="amount") || (nam==="discount"))
{
if (event.target.value === '' || re.test(event.target.value)) {
if(nam==="discount")
{
	let stramt=parseFloat(this.state.grandtot)-parseFloat(val)
	this.setState({[nam]: val,amount:stramt}); 
}else{	 

	 this.setState({[nam]: val}); 
}
  }	
}
else{
  this.setState({[nam]: val},()=>{});
  }

 
}

onInputCustChange = (event) => {
	let grandtot=this.state.grandtot;
	let amount = this.state.amount;
if(parseFloat(amount)>parseFloat(grandtot))
	{
	
	this.setState({errormessage:"Please Enter amount less than outstanding amount",erropen:true});
		
		 return false;
	
}
	if(this.state.discount!==""){
		let newoutstandingamts= parseFloat(this.state.grandtot - this.state.amount).toFixed(2);
		newoutstandingamts=newoutstandingamts - parseFloat(this.state.discount).toFixed(2);
	  
	  this.setState({newoutstandingamt:newoutstandingamts})
	} 
	else{
		let newoutstandingamts= parseFloat(this.state.grandtot - this.state.amount).toFixed(2);
		
	  this.setState({newoutstandingamt:newoutstandingamts})
	}
	
}

handleClose = (e) => {
	let reference= this.state.reference;
	let grandtot=this.state.grandtot;
	let amount = this.state.amount;
    let discount = this.state.discount;
	let newoutstandingamt= this.state.newoutstandingamt;
 if(amount==="")
{
	
	this.setState({errormessage:"Please Enter Amount",erropen:true});
		
		 return false;
	
}
if(parseFloat(amount)>parseFloat(grandtot))
	{
	
	this.setState({errormessage:"Please Enter amount less than outstanding amount",erropen:true});
		
		 return false;
	
}
 this.setState({btndisabled:true,submitbtn:"Processing..."}) 
  
	this.props.invoiceupdateDone(amount+"~"+discount+"~"+newoutstandingamt);
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	 setIsChecked = (isChecked) => {
    this.setState({isChecked });
	this.setState({Checkbox:0});
  }


render (){
 const { ...props } = this.props;
return(
<React.Fragment>


   <Dialog open={this.state.open} onClose={this.onclickpaymentclose} maxWidth="md"   className="popup" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Part Pay</DialogTitle>
      <DialogContent >

<div className="formlist">
<p>Enter the amount you want to pay:</p>
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
	<div className="customerforms">

<ul>
<li>
		
	<p className="popformtext">Reference No.<span className="validation">*</span></p>
	
	
	<p className="popforminputs"><TextField name="reference" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={this.state.reference}
			  inputProps={{tabIndex: "6",maxLength:15}}
			  ref={this.usernameInput}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
              
		  /></p>
		  
		   <div className="clear"></div>
</li>
		
	<li>	
						  
	<p className="popformtext">Outstanding <span className="validation">*</span></p>
		
	
	<p className="popforminputs"><TextField name="grandtot" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={this.state.grandtot}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>	
	<li>	
						  
	<p className="popformtext">Amount to Pay <span className="validation">*</span></p>
		
	
	<p className="popforminputs"><TextField name="amount" 
	   onChange={this.myChangeHandler} 
	   onBlur={this.onInputCustChange.bind(this)}
	   fullWidth
	   value={this.state.amount}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>				  
	<li>	
					  
	<p className="popformtext"> Discount <span className="validation">*</span></p>
	
	
	<p className="popforminputs"><TextField name="discount" 
	   onChange={this.myChangeHandler} 
	   fullWidth onBlur={this.onInputCustChange.bind(this)}
	   value={this.state.discount}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>

<li>	
						  
	<p className="popformtext">New Outstanding Amount<span className="validation">*</span></p>
		
	
	<p className="popforminputs"><TextField name="newoutstandingamt" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={this.state.newoutstandingamt} onBlur={this.onInputCustChange.bind(this)}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>

	

					  
	
		
		
		  </ul>	
			


</div>
		 
		 

 
 
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickpaymentclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	</div>	
	 
						    </DialogContent>
      
    </Dialog>
	
</React.Fragment>

) }
 
} 
	
	
	 





 



	
	





